<svg class="home-area-chart {{ status }}">
  <linearGradient id="gradientNegative" gradientUnits="userSpaceOnUse" x1="0" y1="85.77845690792637" x2="0" y2="0">
    <stop offset="0%" stop-color="var(--color-core-brand-6-1)"></stop>
    <stop offset="100%" stop-color="var(--color-core-brand-6-3)"></stop>
  </linearGradient>
  <linearGradient id="gradientPositive" gradientUnits="userSpaceOnUse" x1="0" y1="85.77845690792637" x2="0" y2="0">
    <stop offset="0%" stop-color="var(--color-core-brand-6-1)"></stop>
    <stop offset="100%" stop-color="var(--color-core-brand-6-3)"></stop>
  </linearGradient>
</svg>
